import React, { HTMLAttributes, ReactNode } from 'react'

import { cn } from '@frame/lib/utils/cn'
import { PrimitiveDataAttribute } from '@frame/types'

type Props = {
  children: ReactNode
  className?: HTMLAttributes<HTMLHeadingElement>['className']
}

export function H2({ children, className }: Props) {
  return (
    <h2
      data-cy={PrimitiveDataAttribute.TW_PRIMITIVE_H2}
      className={cn('text-center text-xl font-semibold text-moss-950', className)}
    >
      {children}
    </h2>
  )
}
